import React from 'react';
import { Stack, Button, Typography, Box } from '@mui/material';
import { Logo } from '../../components/landing/Logo';
import { useResponsive } from '../../services/hooks';
import Page from '../../components/Page';
import Form from '../../components/json-forms/Form';


export default function RecruitmentFormPage() {
  const isDesktop = useResponsive('up', 'lg');

  return (
    <Page title="Rekrutacja">
      <Stack direction={isDesktop ? 'row' : 'column'} justifyContent="space-between" alignItems="center" p={2}>
        <Logo />
        <Button variant="text" href="https://sun-sport.pl/pracuj-z-nami/" target="_blank" color="info" style={{ color: '#4469b4', marginTop: isDesktop ? '0' : '16px', textTransform: 'uppercase' }}>
          Powrót do strony Sun Sport
        </Button>
      </Stack>
      {/* <Form identifier="rekrutacja"/> */}
      <Stack justifyContent="center" alignItems="center" p={20}>
        <Typography variant="h3" color="primary">
        Rekrutacja ruszy niebawem. W razie jakichkolwiek pytań prosimy kierować zapytania na rekrutacja3@sun-sport.pl
        </Typography>
      </Stack>
    </Page>
  );
};
